import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/entities/session/model/authStore';
import { ROUTES } from '@/shared/config/constants';

export function GuestRoute({ children }) {
  const { token } = useAuthStore();

  if (token) {
    return <Navigate to={ROUTES.DEPLOYMENTS} replace />;
  }

  return children;
}
